import styled from 'styled-components';

export default styled.div`
  flex-shrink: 1;
  flex-basis: 50%;
`;



// WEBPACK FOOTER //
// ./packages/smart-home-support/assets/components/HeroContentSpacer.tsx